import { Button } from '@resiliatech/birdsong'
import { pick } from 'lodash'
import { IntakeFlowStep, Priority } from '../../constants'
import {
  PriorityContainer,
  PriorityTitle,
  SlidersContainer,
  StyledSlider,
} from './ConfidenceRating.styled'
import { ActionContainer, Container } from '../../IntakeFlow.styled'

type Props = {
  onBackStep: () => void
  onNextStep: (nextStep: IntakeFlowStep) => void
  priorities: Priority[]
  onUpdateConfidence: (confidenceRatings: Record<string, number>) => void
  confidenceRatings: Record<string, number>
}

export const ConfidenceRating = ({
  onNextStep,
  onBackStep,
  priorities,
  onUpdateConfidence,
  confidenceRatings,
}: Props) => {
  const marks = [
    { value: 0, label: 'Slide Right' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
  ]
  const isNextDisabled =
    Object.values(confidenceRatings).includes(0) ||
    Object.keys(confidenceRatings).length !== priorities.length

  const handleRatingChange = (priority: string, value: number) => {
    const oldEntries = pick(confidenceRatings, priorities)
    onUpdateConfidence({
      ...oldEntries,
      [priority]: value,
    })
  }

  return (
    <Container>
      <SlidersContainer>
        {priorities.map((priority) => (
          <PriorityContainer key={priority}>
            <PriorityTitle>{priority}</PriorityTitle>
            <StyledSlider
              value={confidenceRatings[priority] || 0}
              onChange={(_, value) =>
                handleRatingChange(priority, value as number)
              }
              min={0}
              max={5}
              step={1}
              marks={marks}
            />
          </PriorityContainer>
        ))}
      </SlidersContainer>

      <ActionContainer>
        <Button variant='text' onClick={onBackStep}>
          Back
        </Button>
        <Button
          variant='primary'
          isDisabled={isNextDisabled}
          onClick={() => onNextStep(IntakeFlowStep.OTHER_FOCUS_AREAS)}
          label='Next'
        />
      </ActionContainer>
    </Container>
  )
}
